import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {
  MatDialog,
} from '@angular/material/dialog';

import { TableOption } from 'src/app/invopay/interfaces/Iip-table-options';
import { IpRoleService } from 'src/app/invopay/services/ip-role.service';
import { TableEvent } from 'src/app/shared/components/table/Itable';
import { FnPaymentDetailsComponent } from '../fn-payment-details/fn-payment-details.component';
import { FnConsolidatedService } from '../../services/fn-consoldate.service';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';

//Mock response consolidado;

@Component({
  selector: 'app-fn-pay-invoices',
  templateUrl: './fn-pay-invoices.component.html',
  styleUrls: ['./fn-pay-invoices.component.scss'],
})
export class FnPayInvoicesComponent implements OnInit {
  tableOptions!: TableOption;
  tableOptionsConsolidated!: TableOption;
  propertyOrder: string[] = [];
  selectedInvoicesList?: any;
  totalElements?: any;

  totalsConsolidated?: any;
  consolidatedDetails?: any;
  totalInvoices?: number;
  totalDue?: number;
  totalSuppliers?: number;
  consolidatedName: FormControl = new FormControl('');
  consolidatedDueDate: FormControl = new FormControl('', Validators.required);
  
  completedSteps = new Set<number>();
  mobile!:boolean;

  propertyOrderSelectedItems: string[] = [
    'broker_name',
    'cuit',
    'bank',
    'branch_number',
    'owner_name',
    'id_consolidated',
    'invoices_total',
    'amount',
  ];

  firstFormGroup = this.formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this.formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  isLinear = false;
  type!: 'business' | 'employee' | 'provider';

  selectedItems: any[] = []; // Almacenar ítems seleccionados

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private roleService: IpRoleService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
    private consolidatedService: FnConsolidatedService
  ) {this.checkIfMobile()}

  @HostListener('window:resize', [])
  checkIfMobile() {
    this.mobile = window.innerWidth < 768;
  }

  ngOnInit(): void {
    this.type = this.roleService.getType();
    this.propertyOrder = this.setProperty();

    this.tableOptions = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: [],
      filters: this.setFilters(),
    };

    this.tableOptionsConsolidated = {
      keyTranslate: this.setKeyTranslate(),
      selects: [],
      actions: this.setActions(),
      filters: this.setFilters(),
    };
  }

  setKeyTranslate(): string {
    return 'IP.TABLE.PAY-INVOICES';
  }

  goToStep(event: MouseEvent, stepIndex: number, stepper: MatStepper) {
    event.stopPropagation();
    //Procesar lista de invoices seleccionadas y enviarlas al servicio;
    if (this.selectedInvoicesList) {
      const invoiceData = {
        supplierInvoices: this.selectedInvoicesList,
      };
      this.completedSteps.add(stepIndex-1);

      this.consolidatedService
        .sendInvoicesToConsolidatedTemplate(invoiceData)
        .subscribe({
          next: (response) => {
            this.totalsConsolidated = response;
            // this.consolidatedTemplate = response;
            stepper.selectedIndex = stepIndex;
          },
        });
    }
  }

  returnToStep(){
    this.completedSteps.clear()
  }

  openConfirmDialog(
    event: MouseEvent,
    dialogTemplate: TemplateRef<any>,
    stepIndex: number,
    stepper: any
  ): void {
    event.stopPropagation();
    const dialogRef = this.dialog.open(dialogTemplate);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'confirm') {
        this.generateConsolidated(stepIndex, stepper);
      }
    });
  }

  generateConsolidated(stepIndex: number, stepper: any) {
    if (this.totalsConsolidated) {
      this.completedSteps.add(stepIndex-1);
      this.totalsConsolidated.consolidatedName = this.consolidatedName.value
      this.totalsConsolidated.consolidatedDueDate = this.consolidatedDueDate.value;
      this.consolidatedService
        .generateConsolidated(this.totalsConsolidated)
        .subscribe({
          next: (response) => {
            this.consolidatedDetails = response;
            stepper.selectedIndex = stepIndex;
          },
        });
    }
  }

  isStepCompleted(index: number): boolean {
    return this.completedSteps.has(index);
  }

  isEditable(index: number,stepper: MatStepper): boolean {
    if (stepper.selectedIndex === 2) return false;
    return index <= stepper.selectedIndex;
  }

  onInvoiceSelectionChange(newSelection: any) {
    this.selectedInvoicesList = newSelection.map((invoice: any) => ({
      invoiceId: invoice.invoiceId,
      userId: invoice.brokerId,
    }));
  }

  setFilters(): Array<[string, string]> {
    switch (this.type) {
      case 'business':
      case 'provider':
        return [['IP.TABLE.DASHBOARD.FILTER.DATE-ISSUED', 'date']];
      default:
        return [];
    }
  }

  setProperty(): string[] {
    switch (this.type) {
      case 'business':
        return [
          'broker_name',
          'charge_date',
          'emit_date',
          'expired_date',
          'amount',
        ];
      default:
        return [];
    }
  }

  setActions(): Array<string> {
    switch (this.type) {
      case 'business':
        return ['search'];
      default:
        return [];
    }
  }
  async onAction(tableEvent: TableEvent) {
    switch (tableEvent.event) {
      case 'search':
        const { width, minWidth } = this.getDialogDimensions();
        const dialogRef = this.dialog.open(FnPaymentDetailsComponent, {
          height: 'max-content',
          minHeight: '400px',
          maxHeight: '800px',
          width: width,
          minWidth: minWidth,
          panelClass: 'custom-modal',
          data: {
            isConsolidatedEdited: true,
            info: tableEvent.dataField,
          },
        });

        dialogRef.disableClose = true;
        break;
      default:
        console.warn(
          `Handler for action "${tableEvent.event}" was not defined.`
        );
        break;
    }
  }

  private getDialogDimensions() {
    if (this.breakpointObserver.isMatched(Breakpoints.Web)) {
      return { width: 'max-content', minWidth: '50%' };
    } else {
      return { width: 'max-content', minWidth: '80%' };
    }
  }

  goOut(){
    this.router.navigateByUrl('/invopay/admin/finance/manage-pay-orders');
  }

  downloadCsv(id:any){
    this.consolidatedService.getConsolidateDetails(id).subscribe({
      next: (response) => {
        const headersArray: string[] = ['proveedor/broker', 'Banco', 'sucursal', 'Nro_de_cuenta', 'nombre_del_titular', 'cuit','cantidad_de_facturas', 'ids_de_facturas', 'moneda', 'total'];
        let csv = headersArray.join(',')
        response.content.forEach((val: any) => {
          const row: string[] = [];
          row.push(val.businessName ?? '-')
          row.push(val.bank ?? '-')
          row.push(val.branchNumber ?? '-')
          row.push(val.accountNumber ?? '-')
          row.push(val.ownerName ?? '-')
          row.push(val.cuit ?? '-')
          row.push(val.totalInvoices ?? '-')
          row.push(val.invoicesIds ?? '-')
          row.push(val.currency ?? '-')
          row.push(val.amount ?? '-')
    
          csv = csv + "\n" + row.join(',')
        });
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        let link = document.createElement('a');
        let url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'consolidated-to-pay-file');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);    
      }
    });
  }
}
